import React from 'react'
import { Container, Carousel } from '../../../components'
import { Link } from 'react-router-dom'
import { Card } from '../../blog/components'
import { useViewport } from '../../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBlogs } from '../../../features/blogs/slice'
import { useInternationalization } from '../../../features/i18n'

const MobileComponent = ({data}) => {
  const { translate } = useInternationalization()
  return (
    <Container className="py-10">
      <h3 className="text-center uppercase font-accent mb-5">{translate('BLOG', 'related')}</h3>

      {/* Cards */}
      <div className="-mx-2 text-gray-900 h-full">
        <Carousel slidesToShow={2} slidesToScroll={2} >
          {
            data.map((d, index) => (
              <div className="w-1/2 px-2 h-full" key={index}>
                <Link to={`/blog/${d.id}/detail`}>
                  <Card data={d}/>
                </Link>
              </div>
            ))
          }
        </Carousel>
      </div>
    </Container>
  )
}

const DesktopComponent = ({data}) => {
  const { translate } = useInternationalization()
  return (
    <Container className="py-20">
      <h3 className="uppercase font-accent text-2xl mb-10">{translate('BLOG', 'related')}</h3>

      <div className="flex flex-wrap -mx-4">
        {
          data.map((d, index) => {
            return (
              <div className="w-1/4 px-4 mb-8" key={index}>
                <Link to={`/blog/${d.id}/detail`}>
                  <Card data={d}/>
                </Link>
              </div>
            )
          })
        }
      </div>
    </Container>
  )
}

const RelatedPosts = () => {
  const dispatch = useDispatch()
  const { isMobile } = useViewport()
  const blogs = useSelector(state => state.blogs.data)
  const status = useSelector(state => state.blogs.status)
  const data = blogs.slice(0, 4)

  React.useEffect(() => {
    if(status === 'idle'){
      dispatch(fetchBlogs())
    }
  }, [dispatch, status])

  return isMobile ? <MobileComponent data={data}/> : <DesktopComponent data={data}/>
}

export { RelatedPosts }
